"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _amsPostMessage = require("../wrappers/ams-post-message");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PostMessage = function PostMessage(_ref) {
  var postState = _ref.postState,
      updatePostState = _ref.updatePostState,
      canPostMessage = _ref.canPostMessage,
      postMessage = _ref.postMessage,
      users = _ref.users,
      groups = _ref.groups,
      onPostMessage = _ref.onPostMessage,
      props = _objectWithoutProperties(_ref, ["postState", "updatePostState", "canPostMessage", "postMessage", "users", "groups", "onPostMessage"]);

  var heading = postState.heading,
      message = postState.message,
      type = postState.type,
      target = postState.target,
      filterGroups = postState.filterGroups;

  var doPostMessage = _react["default"].useCallback(function (e) {
    postMessage().then(function () {
      if (typeof onPostMessage === "function") {
        onPostMessage(e);
      }
    });
  }, [postMessage, onPostMessage]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-2 gap-4 w-screen",
    style: {
      maxWidth: "90vw"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "heading",
    className: "font-bold"
  }, "Heading"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "text",
    id: "heading",
    placeholder: "Type the heading...",
    value: heading,
    onChange: function onChange(heading) {
      return updatePostState({
        heading: heading
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "message",
    className: "font-bold"
  }, "Message"), /*#__PURE__*/_react["default"].createElement(_avlComponents.TextArea, {
    id: "message",
    value: message,
    placeholder: "Type a message...",
    onChange: function onChange(message) {
      return updatePostState({
        message: message
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "font-bold"
  }, "Message Type"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    options: _amsPostMessage.MessageTypes,
    onChange: function onChange(type) {
      return updatePostState({
        type: type
      });
    },
    value: type,
    multi: false
  })), !["user", "users"].includes(type) || groups.length < 2 ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "font-bold"
  }, "Filter By Groups"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    options: groups,
    onChange: function onChange(filterGroups) {
      return updatePostState({
        filterGroups: filterGroups
      });
    },
    accessor: function accessor(g) {
      return g.name;
    },
    value: filterGroups,
    multi: true
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-4",
    style: {
      gridTemplateRows: "auto min-content"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "font-bold"
  }, "Message Preview"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white rounded px-2 py-0"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.MarkdownViewer, {
    markdown: message
  }))), !type ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "font-bold"
  }, "Message Target"), type === "user" ? /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    options: users,
    accessor: function accessor(u) {
      return u.email;
    },
    valueAccessor: function valueAccessor(u) {
      return u.email;
    },
    onChange: function onChange(target) {
      return updatePostState({
        target: target
      });
    },
    value: target,
    multi: false
  }) : type === "users" ? /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    options: users,
    accessor: function accessor(u) {
      return u.email;
    },
    valueAccessor: function valueAccessor(u) {
      return u.email;
    },
    onChange: function onChange(target) {
      return updatePostState({
        target: target
      });
    },
    value: target,
    multi: true
  }) : type === "group" ? /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    options: groups,
    accessor: function accessor(g) {
      return g.name;
    },
    valueAccessor: function valueAccessor(g) {
      return g.name;
    },
    onChange: function onChange(target) {
      return updatePostState({
        target: target
      });
    },
    value: target,
    multi: false
  }) : type === "project" ? /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "text",
    readOnly: true,
    value: target
  }) : null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 flex justify-end"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    disabled: !canPostMessage,
    onClick: doPostMessage
  }, "post message")));
};

var _default = (0, _amsPostMessage.postMessageWrapper)(PostMessage);

exports["default"] = _default;